export const GET_EXAM_ROOM_ASSIGNMENTS = "GET_EXAM_ROOM_ASSIGNMENTS"
export const GET_EXAM_ROOM_ASSIGNMENTS_FAIL = "GET_EXAM_ROOM_ASSIGNMENTS_FAIL"
export const GET_EXAM_ROOM_ASSIGNMENTS_SUCCESS = "GET_EXAM_ROOM_ASSIGNMENTS_SUCCESS"

export const ADD_NEW_EXAM_ROOM_ASSIGNMENT = "ADD_NEW_EXAM_ROOM_ASSIGNMENT"
export const ADD_EXAM_ROOM_ASSIGNMENT_SUCCESS = "ADD_EXAM_ROOM_ASSIGNMENT_SUCCESS"
export const ADD_EXAM_ROOM_ASSIGNMENT_FAIL = "ADD_EXAM_ROOM_ASSIGNMENT_FAIL"

export const UPDATE_EXAM_ROOM_ASSIGNMENT = "UPDATE_EXAM_ROOM_ASSIGNMENT"
export const UPDATE_EXAM_ROOM_ASSIGNMENT_SUCCESS = "UPDATE_EXAM_ROOM_ASSIGNMENT_SUCCESS"
export const UPDATE_EXAM_ROOM_ASSIGNMENT_FAIL = "UPDATE_EXAM_ROOM_ASSIGNMENT_FAIL"

export const DELETE_EXAM_ROOM_ASSIGNMENT = "DELETE_EXAM_ROOM_ASSIGNMENT"
export const DELETE_EXAM_ROOM_ASSIGNMENT_SUCCESS = "DELETE_EXAM_ROOM_ASSIGNMENT_SUCCESS"
export const DELETE_EXAM_ROOM_ASSIGNMENT_FAIL = "DELETE_EXAM_ROOM_ASSIGNMENT_FAIL"

export const RESET_EXAM_ROOM_ASSIGNMENT_LAST_ACTION_SUCCESS = "RESET_EXAM_ROOM_ASSIGNMENT_LAST_ACTION_SUCCESS";


// Places
export const GENERATE_EXAM_ROOM_SEATS         = "GENERATE_EXAM_ROOM_SEATS";
export const GENERATE_EXAM_ROOM_SEATS_SUCCESS = "GENERATE_EXAM_ROOM_SEATS_SUCCESS";
export const GENERATE_EXAM_ROOM_SEATS_FAIL    = "GENERATE_EXAM_ROOM_SEATS_FAIL";

export const GET_EXAM_ROOM_SEATS         = "GET_EXAM_ROOM_SEATS";
export const GET_EXAM_ROOM_SEATS_SUCCESS = "GET_EXAM_ROOM_SEATS_SUCCESS";
export const GET_EXAM_ROOM_SEATS_FAIL    = "GET_EXAM_ROOM_SEATS_FAIL";

export const RESET_EXAM_ROOM_SEATS         = "RESET_EXAM_ROOM_SEATS";
export const RESET_EXAM_ROOM_SEATS_SUCCESS = "RESET_EXAM_ROOM_SEATS_SUCCESS";
export const RESET_EXAM_ROOM_SEATS_FAIL    = "RESET_EXAM_ROOM_SEATS_FAIL";


